import LendingHomeError from './lendingHomeError';

export default class LendingHomeFatalError extends LendingHomeError {
  constructor(message, error, options) {
    super(message, error, options);
    this.name = 'LendingHomeFatalError';
    this.fatal = true;
  }
}
